import HTTPServices from "../HTTPServices/httpService";

const orderDetailServices = {
  //(1)
  saveOrderDetailAndMeasurement: async function (savingObj) {
    console.log(
      "'saveOrderDetailAndMeasurement' service called : " + savingObj
    );
    let result = await HTTPServices.post_ReturnFullObject(
      "orderDetail/saveOrderDetailAndMeasurement",
      savingObj
    );

    return result;
  },
  //(2)
  deleteByOrderDetailGUID: async function (orderDetailGUID) {
    console.log(
      "'deleteByOrderDetailGUID' service called : " + orderDetailGUID
    );
    let result = await HTTPServices.post(
      "orderDetail/deleteByOrderDetailGUID",
      orderDetailGUID
    );

    return result;
  },
};

export default orderDetailServices;
